/**
 * Sichere Lesart von localStorage; verhindert Crash bei korruptem JSON.
 */
export function getStoredUser() {
  try {
    const raw = localStorage.getItem('user');
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function getAuthToken() {
  const u = getStoredUser();
  const t = u?.token;
  return typeof t === 'string' && t.length > 0 ? t : null;
}

let redirecting = false;

/**
 * Session ungültig (z. B. 401, JWT malformed): Speicher leeren und Login – nur einmal, kein Loop.
 */
export function clearSessionAndRedirectToLogin() {
  if (redirecting) return;
  if (window.location.pathname === '/login') {
    localStorage.removeItem('user');
    return;
  }
  redirecting = true;
  localStorage.removeItem('user');
  window.location.replace('/login');
}
